import React from 'react';

import { SmartyUsAutocompleteSuggestionT } from '@consumer-frontend/nc-utils';
import {
  ListGroup,
  ListGroupItem,
} from '@consumer-frontend/shared-ui';

import '@consumer-bootstrap/netcredit.scss';
// eslint-disable-next-line import/order
import '@consumer-bootstrap/brands/netcredit/form/address-suggestions.scss';

export type NcAddressSuggestionsPropsT = {
  getSuggestionId: (index: number) => string;
  highlightedSuggestionIndex: number;
  onSelectSuggestion: (suggestion: SmartyUsAutocompleteSuggestionT) => void;
  suggestions: SmartyUsAutocompleteSuggestionT[];
  suggestionsRef: React.RefObject<HTMLDivElement | null>;
  suggestionsStyle: React.CSSProperties;
};
export type NcAddressSuggestionsT = React.FC<NcAddressSuggestionsPropsT>;

export const NcAddressSuggestions: NcAddressSuggestionsT = ({
  getSuggestionId,
  highlightedSuggestionIndex,
  onSelectSuggestion,
  suggestions,
  suggestionsRef,
  suggestionsStyle,
}) => {
  const suggestionKey = (suggestion: SmartyUsAutocompleteSuggestionT) => (
    `${suggestion.streetLine}-${suggestion.secondary}-${suggestion.city}-${suggestion.state}-${suggestion.zipcode}`
  );

  return (
    <div
      className="address-suggestions"
      ref={suggestionsRef}
      style={suggestionsStyle}
    >
      <ListGroup
        aria-label="Address suggestions"
        id="address-suggestions"
        role="listbox"
      >
        {suggestions.map((suggestion, index) => (
          <ListGroupItem
            action
            active={index === highlightedSuggestionIndex}
            aria-selected={index === highlightedSuggestionIndex}
            id={getSuggestionId(index)}
            key={suggestionKey(suggestion)}
            onMouseDown={(event) => {
              event.preventDefault();
              onSelectSuggestion(suggestion);
            }}
            role="option"
          >
            <div className="address-suggestion-content">
              <strong>{suggestion.streetLine}</strong>
              {suggestion.secondary && <span>{suggestion.secondary}</span>}
              <span>{`${suggestion.city}, ${suggestion.state} ${suggestion.zipcode}`}</span>
            </div>
          </ListGroupItem>
        ))}
      </ListGroup>
    </div>
  );
};
